enum actionRole {
	null,
	create,
	update,
	select,
	delete,
	moveUp,
	moveDown,
	checked,
	reply,
	flowForm
}

export { actionRole };
